import React from 'react';

/**
 * Card de estatística da Agenda — número "feito de total" + barra (quando
 * `total` é informado) ou um valor textual livre (ex: "12 dias", "Quinta").
 */
export default function AgendaStatCard({ titulo, feito, total, valor, mensagem }) {
  const temFracao = total !== undefined;
  const pct = temFracao && total > 0 ? Math.round((feito / total) * 100) : 0;

  return (
    <div className="bg-white border border-gray-200 rounded-2xl p-4 text-center">
      <p className="text-[10px] text-gray-500 font-manrope uppercase tracking-widest mb-2">{titulo}</p>
      {temFracao ? (
        <>
          <p className="text-2xl font-outfit font-light text-gray-900 mb-2">
            {feito} <span className="text-sm text-gray-500">de</span> {total}
          </p>
          <div className="h-2 bg-gray-100 rounded-full overflow-hidden mb-2">
            <div className="h-full bg-[#1E3A8A] rounded-full transition-all duration-500" style={{ width: `${pct}%` }} />
          </div>
        </>
      ) : (
        <p className="text-2xl font-outfit font-light text-gray-900 mb-2">{valor}</p>
      )}
      <p className="text-xs text-[#1E3A8A] font-manrope">{mensagem}</p>
    </div>
  );
}
